import { Controller } from "@hotwired/stimulus"

// Counts a server-rendered number up from zero on first view.
// The final value is already in the DOM, so no JS means no harm.
export default class extends Controller {
  static values = { to: Number, duration: { type: Number, default: 1400 } }

  connect() {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reduced || !("IntersectionObserver" in window) || !this.toValue) return

    this.observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        this.observer.disconnect()
        this.animate()
      }
    }, { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  animate() {
    const start = performance.now()
    const step = now => {
      const progress = Math.min((now - start) / this.durationValue, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      this.element.textContent = Math.round(this.toValue * eased).toLocaleString("en-US")
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}
